import { render, staticRenderFns } from "./check-date-box.vue?vue&type=template&id=60a003a8&scoped=true"
import script from "./check-date-box.vue?vue&type=script&lang=js"
export * from "./check-date-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a003a8",
  null
  
)

export default component.exports